const AannouncementsData = [
  {
    title: "Welcome to Spice Garden",
    content: [
      "Experience the authentic taste of India in the heart of the city. Our restaurant brings you traditional recipes passed down through generations, prepared with the finest spices and ingredients sourced directly from India.",
      "Since 2010, we have been serving the community with genuine Indian hospitality and flavors. Our master chef, trained in the royal kitchens of Rajasthan, brings over 20 years of culinary expertise to every dish.",
      "Whether you're craving spicy curries, aromatic biryanis, or sweet Indian desserts, our diverse menu offers something for every palate and dietary preference."
    ]
  },
  {
    title: "Our Philosophy",
    content: [
      "“Annam Brahma” – Food is Divine. We believe in serving not just meals, but experiences that connect you to the rich cultural heritage of India through authentic flavors and traditional cooking methods.",
      "Our commitment to authenticity means we import key spices from India and follow traditional cooking techniques including tandoor cooking and slow-cooked curries."
    ]
  },
  {
    title: "Awards & Recognition",
    content: [
      "Winner of “Best Indian Restaurant 2023” and featured in Food & Travel Magazine. Our Butter Chicken and Biryani have been rated among the city's best by food critics and customers alike."
    ]
  },
];

export default AannouncementsData;